import * as zod from 'zod'
import type { DateFormat, PersonalSettings } from './PersonalSettings'
import type { ThemeFont, ThemeSize } from './Theme'

export const SortDirectionSchema = zod.union([
  zod.literal('ASC'),
  zod.literal('DESC'),
  zod.literal('NONE'),
])
export type SortDirection = zod.infer<typeof SortDirectionSchema>

export const SortModeSchema = zod.union([
  zod.literal('CUSTOM'),
  zod.literal('NAME'),
])
export type SortMode = zod.infer<typeof SortModeSchema>

export type AvailableDateFormat = {
  title: string
  value: DateFormat
}
export type SortingConfiguration = {
  sortMode: SortMode
  sortDirection: SortDirection
}
export type ThemeSettings = {
  themeSize: ThemeSize
  themeFont: ThemeFont
}
export type DeviceSortingSettings = SortingConfiguration
export type DashboardSortingSettings = SortingConfiguration
export type AccountSettings = ThemeSettings & PersonalSettings & {
  dashboardsSettings: DashboardSortingSettings
  deviceConfigurationSettings: DeviceSortingSettings
}
export type TwoFactorAuthenticationSetupKey = {
  qrCode: string
  secret: string
}
